import { LocalNotifications } from '@capacitor/local-notifications';

import { incBadge, clearUpdateBadge } from './badges';
export async function onChatMessage(msg) {
    console.log("msgmsgmsgmsg",msg)
  await LocalNotifications.schedule({
    notifications: [{
      id: Date.now() % 2147483647,
      title: `New message from ${msg.username || 'Someone'}`,
      body: msg.message || '',
      channelId: 'chat',
      extra: { type: 'chat', roomId: sessionStorage.getItem('roomId') }
    }]
  });
  await incBadge('chat', 1);
}


export async function onParticipantWaiting(raw) {
  console.log('onParticipantWaiting raw =', raw);

  // 1) raw -> array normalize
  const list = Array.isArray(raw) ? raw : [raw];

  // 2) roomId எங்கிருந்து?
  const roomId = sessionStorage.getItem('roomId') || raw?.roomId || list[0]?.roomId || '';

  // 3) ஒவ்வொரு participant-க்கும் ஒரு local notification
  for (const ev of list) {
    const username =
      ev?.user?.username ||
      ev?.user?.email ||
      ev?.user?.name ||
      'Someone';

    // Android 13+க்கு local notification permission வேண்டியது
    try { await LocalNotifications.requestPermissions(); } catch {}

    // channel "waiting" இருக்கா? (நம்ம initNotifications-ல create பண்ணியிருக்கணும்)
    const notifId = Date.now() % 2147483647; // 32-bit int அளவுக்கு

    await LocalNotifications.schedule({
      notifications: [{
        id: notifId,
        title: 'Participant waiting',
        body: `${username} is requesting to join`,
        channelId: 'waiting', // initAndroidChannels() உருவாக்கும் channel
        extra: { type: 'waiting', roomId }
      }]
    });

    // 4) badge++
    await incBadge('waiting', 1);
  }
}
